import { render, staticRenderFns } from "./HcRecords.vue?vue&type=template&id=037923d1&scoped=true&"
import script from "./HcRecords.vue?vue&type=script&lang=js&"
export * from "./HcRecords.vue?vue&type=script&lang=js&"
import style0 from "./HcRecords.vue?vue&type=style&index=0&id=037923d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037923d1",
  null
  
)

export default component.exports